export const config = (labels, prop) => ({
	id: `${prop}Column`,
	label: labels[prop],
	propName: prop,
	width: 'minmax(10rem, 1fr)',
	align: 'right',
	headerAlign: 'right'
});
